import { HStack, Icon, Stack } from "@chakra-ui/react";
import { Controller, UseFormReturn } from "react-hook-form";
import { Heading16 } from "components/Heading";
import NewCaminoOption from "components/Selectable/NewCaminoOption";
import CaminoIndividualMeetingPerson from "components/Icon/CaminoIndividualMeetingPerson";
import CaminoGroupMeetingPeople from "components/Icon/CaminoGroupMeetingPeople";
import CaminoGroupMeetingRecurring from "components/Icon/CaminoGroupMeetingRecurring";

interface MeetingTypeFormProps {
  form: UseFormReturn<any>;
  onChangeCallback?: () => void;
  /** Called instead of setting the form value when the user picks
   *  `group_session_recurring`. Use this on `new` templates to route the
   *  user into the import flow (Google Calendar pick) rather than letting
   *  them stub out a recurring template that has no calendar event to
   *  attach to. */
  onRecurringSelected?: () => void;
}

const options = [
  {
    value: "group_session_recurring",
    label: "Group Session (Recurring)",
    description: "Trainings, Cohorts, Group Meetings\nPre-scheduled on a recurring basis",
    icon: <Icon as={CaminoGroupMeetingRecurring} color="linkBlue.500" boxSize={5} />,
  },
  {
    value: "group_session_adhoc",
    label: "Group Session (Ad-hoc)",
    description: "Trainings, Cohorts, Group Meetings\nScheduled as needed",
    icon: <Icon as={CaminoGroupMeetingPeople} color="groupBlue.400" boxSize={5} />,
  },
  {
    value: "individual",
    label: "Individual",
    description: "1:1, 1:2, Individualized Meetings\nScheduled as needed",
    icon: <Icon as={CaminoIndividualMeetingPerson} color="singlePink.400" boxSize={5} />,
  },
];

export default function TemplateMeetingTypeForm({ form, onChangeCallback, onRecurringSelected }: MeetingTypeFormProps) {
  const { control } = form;

  return (
    <Controller
      control={control}
      name="meetingType"
      render={({ field }) => (
        <Stack>
          <Heading16>Select Meeting Type</Heading16>
          <HStack>
            {options.map((opt) => (
              <NewCaminoOption
                key={opt.value}
                isChecked={field.value === opt.value}
                onChange={() => {
                  // Recurring templates must be created via Google Calendar
                  // import — there's no in-form way to fill `recurringEventExternalUrl`.
                  // When the caller wires onRecurringSelected, route there instead.
                  if (opt.value === "group_session_recurring" && onRecurringSelected) {
                    onRecurringSelected();
                    return;
                  }
                  field.onChange(opt.value);
                  onChangeCallback?.();
                }}
                {...opt}
              />
            ))}
          </HStack>
        </Stack>
      )}
    />
  );
}
